module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "u8osZ3bGameqNctLi7LlS75",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "u8XqeWeEcCPu2WJmsPBcdv4"
    }
  }), _vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Adult conversations often meander into the subject, “What did your father do?” and my response, “He was a mobster,” is usually a conversation stopper. While this response frequently derails small talk, it is true. My dad was a small-time organized crime boss for well over twenty years, beginning in the 1950s.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("You might have memories of neighborhoods like mine in the North End of Hartford. You remember luncheonettes like Pal’s, the place my dad owned and if the topic comes up, you always defend its honor as the best place ever. You watched “The Untouchables” and “Dragnet” on TV and heard tales of mobsters on classic serial radio shows. Those characters’ lives were so far removed from yours; they were an exciting escape from reality. But this tabloid header, made for radio, TV and movie life was my life.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The mobsters, illegal activity, racism, sexism, and violence in this book aren’t an exercise with artistic license. This is how my life was, and as such, I make no apologies for it. You don’t choose the time or family you are born into; you can only play the hand you are dealt.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It’s impossible to separate the threads of mobster life with my family life but as a filmmaker and storyteller, I want to document these stories before I get too old to remember them. I had many internal debates before I decided to write this as I knew there was no way to recount my real-life mob stories without also exposing my family dysfunction which was in some part the result of my father’s unlikely occupation. But my dad, Geno, is long past, as are all his crew members and I’ve changed the names of any of my relatives who are still living. My mom, Rena, God rest her soul, passed away in 2011, but I spent many hours with her in her last years. We talked about my memories, which she either confirmed or corrected, and we shared our perspectives about that time, so the stories in this book are as true as the two of us recalled.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Those of you who are interested in the gangster life will appreciate this book because the stories here are all based on real events that occurred in my life until I reached adulthood. Please be advised some of them are graphic.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I hope you are as entertained reading this book as I was writing it. If nothing else, you’ll get a sense of what life was like growing up in a different place and time.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a185930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/intro.vue
// module id = 69
// module chunks = 0